export const APP_VERSION = "v2.6.0";
